// components
import { Box } from '@interstate/components/Box';
import { Spinner } from '@interstate/components/Spinner';

export interface IFieldUpdatingSpinnerProps {
    testId: string;
    ariaLabel?: string;
}

/**
 * Inline spinner for a single input whose value is being recalculated. Not `PaymentLoading`/
 * `LoadingSection`, which overlay a whole card; this sits in the input's trailing slot.
 */
export const FieldUpdatingSpinner = ({ testId, ariaLabel = 'Updating value' }: IFieldUpdatingSpinnerProps) => (
    <Box data-testid={testId} sx={{ display: 'inline-flex', alignItems: 'center' }}>
        <Spinner size={16} aria-label={ariaLabel} />
    </Box>
);
